import React from 'react';
import { Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import Loader from 'components/layout/Loader';

import List from 'components/List';

class ClientStripeAccounts extends React.Component {
  render() {
    const {
      intl: { messages },
      entityLoaded,
      list,
    } = this.props;

    const columns = ['Account Id', messages.projects];
    const tBody = [];
    for (let i = 0; i < list.data.list.length; i++) {
      const { id, account_id: accountId, white_label_projects: whiteLabelProjects } = list.data.list[i];

      tBody.push(
        <tr key={id}>
          <td className="v-align-middle semi-bold">{accountId}</td>
          <td className="v-align-middle">{whiteLabelProjects ? whiteLabelProjects.join(', ') : '-'}</td>
        </tr>
      );
    }

    const resultTable =
      list.pending || !entityLoaded ? (
        <Loader />
      ) : (
        <Table responsive hover>
          <thead>
            <tr>
              {columns.map((column, i) => {
                return (
                  <th key={i} className={column === messages.actions ? 'text-right' : ''}>
                    {column}
                  </th>
                );
              })}
            </tr>
          </thead>
          <ReactCSSTransitionGroup
            transitionName="tablerows"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={1}
            component="tbody"
          >
            {tBody}
          </ReactCSSTransitionGroup>
        </Table>
      );

    return (
      <div className="clearfix padding-20 sm-padding-10">
        <List listName="stripeAccounts" url="/api/stripe/accounts.json" list={list}>
          {resultTable}
        </List>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    list: state.list.stripeAccounts,
  };
};

export default injectIntl(connect(mapStateToProps)(ClientStripeAccounts));
